import React from 'react';
import Spinner from '@narvar/nth-spinner';
import PropTypes from 'prop-types';

export const ReturnsButton = ({ tier, big, text, loading, disableButton, onClick, s }) => (
  <button
    className={[
      'return-button',
      'btn',
      s.button ? s.button : null,
      tier ? `narvar-btn-${tier}` : null,
      big ? s.button_big : null,
    ]
      .filter(Boolean)
      .join(' ')}
    data-test="return-button-next"
    disabled={disableButton}
    onClick={onClick}
  >
    <p className={`return-button-text ${s.button_text}`}>{text}</p>
    <div className={`${s.button_spinner_container}`}>{loading && <Spinner width="30px" />}</div>
  </button>
);

ReturnsButton.propTypes = {
  tier: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  big: PropTypes.bool,
  text: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  disableButton: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  s: PropTypes.object.isRequired,
};

ReturnsButton.defaultProps = {
  tier: 'primary',
  big: false,
  loading: false,
  disableButton: false,
};
